import React, { useState, useRef, useEffect } from "react";
import { Button, useTheme, Box, Typography, Tooltip } from "@mui/material";
import { tokens } from "../../../assets/theme";
import { postAttachment } from "../../../hooks/attachment";
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
//import { BlobServiceClient } from "@azure/storage-blob";

export default function DrumPhotoDialog(props) {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [isMobile, setIsMobile] = useState(false);
    const [image, setImage] = useState(null);
    const [imageBlob, setImageBlob] = useState(null); // Store the captured image as a Blob
    const [cameras, setCameras] = useState([]);
    const [selectedCamera, setSelectedCamera] = useState(null);
    const [showCamera, setShowCamera] = useState(false);
    const [showSpinner, setShowSpinner] = useState(false);
    const videoRef = useRef(null);
    const canvasRef = useRef(null);

    //const AZURE_CONTAINER_URL = "https://axioncoretestsa.blob.core.windows.net/axjo-recycling-test";

    useEffect(() => {
        const isMobileDevice = /Mobi|Android/i.test(navigator.userAgent);
        setIsMobile(isMobileDevice);

        console.log('Looking for cameras...');

        navigator.mediaDevices.enumerateDevices()
            .then((devices) => {
                const videoDevices = devices.filter(device => device.kind === 'videoinput');
                setCameras(videoDevices);
                if (videoDevices.length > 0) {
                    setSelectedCamera(videoDevices[0].deviceId);
                } else {
                    console.log('No video devices found');
                }
            })
            .catch((err) => console.error('Error fetching devices: ', err));
    }, []);

    useEffect(() => {
        if (selectedCamera) {
            startCamera(selectedCamera);
        }
    }, [selectedCamera]);

    const startCamera = (deviceId) => {
        const constraints = {
            video: {
                deviceId: { exact: deviceId },
                width: { ideal: 1920 },
                height: { ideal: 1080 }
            }
        };

        navigator.mediaDevices.getUserMedia(constraints)
            .then((stream) => {
                if (videoRef.current) {
                    videoRef.current.srcObject = stream;
                }
            })
            .catch((err) => console.error('Error accessing camera: ', err));
    };

    const openCamera = () => {
        navigator.mediaDevices.getUserMedia({ video: true })
            .then((stream) => {
                videoRef.current.srcObject = stream;
            })
            .catch((err) => console.error("Error accessing camera:", err));
        setShowCamera(true);
    };

    const closeCamera = () => {
        const video = videoRef.current;
        console.log ("closeCamera", video);
        if (video === null) return;
        
        video.srcObject.getTracks().forEach((track) => track.stop());
        //videoRef.current.srcObject = null;
    };

    const handleCameraChange = (camera) => {

        if (camera === selectedCamera) {

            //setSelectedCamera(null);
            setShowCamera(false);
            //closeCamera();
        } else {
            setShowCamera(true);
            setSelectedCamera(camera);
            openCamera();
        }
    };

    const captureImage = () => {
        setShowSpinner(true);

        const video = videoRef.current;
        const canvas = canvasRef.current;
        const context = canvas.getContext("2d");

        console.log("vid ref", video, video.videoWidth, video.videoHeight);

        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;


        context.drawImage(video, 0, 0, canvas.width, canvas.height);
        canvas.toBlob((blob) => {

            uploadImageToBlob(blob);
            //setImageBlob(blob); // Store the captured image as a Blob
            //setImage(URL.createObjectURL(blob)); // Display the captured image
        }, "image/png");

        //video.srcObject.getTracks().forEach((track) => track.stop());
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const imageURL = URL.createObjectURL(file);
            setImage(imageURL);
            setImageBlob(file); // Store the uploaded image file as a Blob
        }
    };

    // const attachmentsQuery = useQuery(
    //     ["attachments", props.drumId],
    //     () => getAttachmentsForDrum(props.drumId),
    //     {}
    // );

    const formData = (attachment) => {
        let formData = new FormData();

        formData.append("returndrumId", props.drumId); //######
        formData.append("fileName", attachment.fileName);
        formData.append("fileType", attachment.fileType);
        formData.append("fileData", attachment.fileData);

        console.log("formdata returns:", formData.values[0], formData.length, formData);

        return formData;
    }


    const uploadImageToBlob = (blob) => {

        if (!blob) console.log("uploadImageToBlob blob is null");

        const fileName = `image_${Date.now()}.png`;

        const newAttachement = {
            //###drumId: props.drumId,
            returndrumId: props.drumId,
            fileName: fileName,
            fileType: "image/png",
            //filePath: file.name,
            fileData: blob,
            //thumbnail: URL.createObjectURL(file), // Generate thumbnail as a data URL
        };

        postAttachment(formData(newAttachement)).then(() => {
            console.log("Attachment posted!");
            props.attachmentsQuery.refetch();
            setShowSpinner(false);
            // setAttachment({});
            //setOpenPopup(false);
            //data.refetch();
            //setShowBackdrop(false);
        }).catch((error) => {
            console.log(error);
            //setShowBackdrop(false);
            setShowSpinner(false);
            alert(`Could not save Attachment.`);
        })
    };


    if (showCamera === false) {
        closeCamera();
    }


    return (
        <>

            {showSpinner &&
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%', position: 'absolute', top: '0', left: '0', zIndex: '1000', backgroundColor: 'rgba(0, 0, 0, 0.3)' }}>
                    <span style={{ backgroundColor: "rgba(255, 255, 255, 1)", zIndex: '10', width: "150px", height: "150px", justifyContent: 'center', alignItems: 'center', display: 'flex', borderRadius: '5px' }}>

                        <img width="50px" height="50px" src="../../../../assets/axion_spinner_white.gif" alt="processing..."></img>
                    </span>
                </div>
                // <div style={{ position: 'fixed',
                //     top: 0,
                //     left: 0,
                //     width: '100%',
                //     height: '100%',
                //     backgroundColor: 'rgba(0, 0, 0, 0.5)', /* Darken background */
                //     display: 'flex',
                //     justifyContent: 'center',
                //     alignItems: 'center',
                //     zIndex: 1000}}><span width="200px" sx={{backgroundColor: "#ff00ff", zIndex: '1001', width: "200px", height: "200px"}} height="200px"><img width="50px" height="50px" src="../../../../assets/axion_spinner_white.gif" alt="processing..."></img></span></div>
            }


            <div>
                {/* <h1>Capture or Upload a Picture</h1> */}


                {!image && (
                    <>
                        <br />
                        {!isMobile && (
                            <>

                                {!showCamera && (
                                    <>
                                        <div>

                                            <Tooltip title={<Typography fontSize="12px">Click to start camera</Typography>}>
                                                <Button onClick={openCamera}>
                                                    <Box sx={{ width: "145px", height: "120px", alignContent: "center", marginBottom: "20px" }} backgroundColor={colors.primary[900]} ><CameraAltIcon fontSize="large" /></Box>
                                                </Button>
                                            </Tooltip>
                                            {/* <Button onClick={openCamera}>blä</Button> */}
                                            {/* <Button onClick={closeCamera}>Close</Button> */}
                                        </div>
                                    </>
                                )}



                                {showCamera && (
                                    <>
                                        <div>
                                            {cameras.map((camera, index) => (
                                                <Button key={camera.deviceId} value={camera.deviceId}
                                                    sx={{
                                                        backgroundColor: selectedCamera === camera.deviceId ?  colors.dashbordGreen[500] : colors.primary[900],
                                                        "&:hover": {
                                                            backgroundColor: colors.dashbordGreen[400],
                                                            borderColor: "#5e7939",
                                                            boxShadow: "none",
                                                        },
                                                        marginRight: "15px"
                                                    }} onClick={() => handleCameraChange(camera.deviceId)}
                                                >
                                                    {camera.label.substring(0, camera.label.indexOf('(') - 1) || `Camera ${index + 1}`}
                                                </Button>
                                            ))}
                                        </div>
                                        <div>
                                            <video ref={videoRef} width="300" height="200" autoPlay onClick={captureImage} alt="Click to capture image"></video>
                                        </div>
                                    </>
                                )}
                            </>
                        )}
                    </>
                )}

                {image && (
                    <>
                        <div>
                            {cameras.map((camera, index) => (
                                <Button key={camera.deviceId} value={camera.deviceId}
                                    sx={{
                                        backgroundColor: colors.dashbordGreen[500],
                                        "&:hover": {
                                            backgroundColor: colors.dashbordGreen[400],
                                            borderColor: "#5e7939",
                                            boxShadow: "none",
                                        },
                                        marginRight: "15px"
                                    }} onClick={() => setSelectedCamera(camera.deviceId)}
                                >
                                    {camera.label.substring(0, camera.label.indexOf('(') - 1) || `Camera ${index + 1}`}
                                </Button>
                            ))}
                        </div>
                        <div>
                            {/* <h2>Captured Image:</h2> */}
                            <img src={image} alt="Captured" style={{ width: "300px" }} />
                            {/* <button onClick={uploadImageToBlob}>Upload to Azure</button> */}
                        </div>
                    </>
                )}

                <canvas ref={canvasRef} style={{ display: "none" }} width="300" height="200"></canvas>
            </div>
        </>
    );
}